import { CircularProgress, Typography } from '@mui/material';
import BankOperationDetails from '../ReconcileTransactions/BankOperation/BankOperationDetails';
import { Column, Divider } from 'further-ui/components/Layout';
import RadioButtons from 'further-ui/components/RadioButtons';
import React from 'react';

const dateFormatOptions = [
  { label: 'dd/mm/yyyy', value: 'dd/MM/yyyy' },
  { label: 'mm/dd/yyyy', value: 'MM/dd/yyyy' },
  { label: 'dd/mm/yy', value: 'dd/MM/yy' },
  { label: 'mm/dd/yy', value: 'MM/dd/yy' },
];

type OperationPreview = Pick<
  React.ComponentProps<typeof BankOperationDetails>,
  'date' | 'description' | 'counterparty' | 'spent' | 'received'
> & {
  currency: React.ComponentProps<
    typeof BankOperationDetails
  >['accountCurrency'];
};

type Props = {
  dateFormat?: string;
  onDateFormatChange: (dateFormat: string) => void;
  operationPreview?: OperationPreview;
  isLoadingPreview: boolean;
};

const Settings: React.FC<Props> = ({
  dateFormat,
  onDateFormatChange,
  operationPreview,
  isLoadingPreview,
}) => {
  return (
    <Column spacing="lg">
      <Column spacing="sm">
        <Typography variant="h6">Data layout setting</Typography>
        <Typography variant="body2">
          Select the date format used in your bank statement. This will be
          applied to transactions you're importing.
        </Typography>
      </Column>
      <RadioButtons
        direction="row"
        name="date-format"
        value={dateFormat ?? null}
        onChange={onDateFormatChange}
        options={dateFormatOptions}
      />
      <Divider />
      <Column spacing="sm">
        <Typography variant="h6">Transaction preview</Typography>
        {isLoadingPreview ? (
          <CircularProgress />
        ) : (
          !!dateFormat &&
          operationPreview && (
            <BankOperationDetails
              date={operationPreview.date}
              description={operationPreview.description}
              counterparty={operationPreview.counterparty}
              spent={operationPreview.spent}
              received={operationPreview.received}
              accountCurrency={operationPreview.currency}
            />
          )
        )}
      </Column>
    </Column>
  );
};

export default Settings;
